// import { PostHttp } from "../../../faetures/fetch";
// import { useState } from "react";


// function AppFindContiner({data, setData, HeadComp, DataComp, className, host, propHead, propsData}) {
//     const [dataTable, setDataTable] = useState({});

//     function onClickSend() {
//         PostHttp(host, JSON.stringify(data)).then((resolve) => {
//             if (typeof resolve === 'object' && resolve !== null) {
//                 if (resolve[0] === 1 && resolve['data']) {
//                     setDataTable(resolve['data']);
//                 } else {
//                     setDataTable({});
//                 }
//             } else {
//                 setDataTable({});
//             }
//         }).catch(() => {
//             setDataTable({})
//         })
//     }
    

//     return (
//         <div className={className}>
//             <HeadComp data={data} setData={setData} onClickSend={onClickSend} {...propHead} />
//             <DataComp data={dataTable} {...propsData} />
//         </div>
//     )
// }

// export default AppFindContiner;


import { PostHttp } from "../../../faetures/fetch";
import { useState } from "react";

/**
 * AppFindContiner: A reusable container component for data fetching and display.
 * It manages filter criteria, handles data fetching, and renders header and data components.
 * This component provides a flexible structure for creating search/filter interfaces with dynamic data display.
 */
function AppFindContiner({data, setData, HeadComp, DataComp, className, host, propHead, propsData}) {
    // State to hold the fetched data
    const [dataTable, setDataTable] = useState({});

    
    // Handles the data fetching process when triggered (e.g., by a button click)
    function onClickSend() {
        PostHttp(host, JSON.stringify(data)).then((resolve) => {
            // Check if the response is a valid object
            if (typeof resolve === 'object' && resolve !== null) {
                // If the request was successful and contains data, update the state
                if (resolve[0] === 1 && resolve['data']) {
                    setDataTable(resolve['data']);
                } else {
                    // If no data or unsuccessful, set an empty object
                    setDataTable({});
                }
            } else {
                // If the response is not an object, set an empty object
                setDataTable({});
            }
        }).catch(() => {
            // In case of any error, set an empty object
            setDataTable({})
        })
    }
    
    return (
        <div className={className}>
            {/* Render the header component with filter controls */}
            <HeadComp 
                data={data} 
                setData={setData} 
                onClickSend={onClickSend} 
                {...propHead} // Spread additional props for flexibility
            />
            {/* Render the data display component */}
            <DataComp 
                data={dataTable} 
                {...propsData} // Spread additional props for flexibility
            />
        </div>
    )
}

export default AppFindContiner;